import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { FaList } from "react-icons/fa";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

export const renderColumns = (handleEdit, handleDelete, handleList) => {
  return [
    {
      dataIndex: "product_code",
      key: "product_code",
      title: "Kode Product",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Kategori",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Deskripsi",
      width: "25%",
    },
    {
      dataIndex: "min_price",
      key: "min_price",
      title: "Harga Minimal",
    },
    {
      dataIndex: "max_price",
      key: "max_price",
      title: "Harga Maximal",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "12%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_product}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          {record.id !== 4 && record.id !== 5 && (
            <CanAccess
              role={AuthorizationList.view_product}
              yes={
                <div className="mr-2" onClick={() => handleList(record)}>
                  <FaList
                    style={{
                      fontSize: 24,
                      color: "#2C465C",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
          )}
        </div>
      ),
    },
  ];
};
